import React, { useCallback, useState } from "react";
import { useDispatch } from "react-redux";
import { officeApi } from "../../api/config";
import { PopupChange } from "../../reducers/config";
import ToggleBtn from "../ToggleBtn/ToggleBtn";

type Props = {
  data: any;
  ReportBlind: (data: any, id: string) => void;
};

const ReportCard = ({ data, ReportBlind }: Props) => {
  const dispatch = useDispatch();
  const {
    ctts_id,
    ctts_ctts,
    bbs_nm,
    ctts_ctg_nm,
    alert_sts_cd,
    alert_type_nm,
    alert_reg_login_nm,
    ctts_reg_login_nm,
    alert_id,
  } = data;

  //FIXME: 노출여부 추후 업데이트
  const Blind = useCallback(() => {
    ReportBlind(alert_id, alert_sts_cd === "normal" ? "block" : "normal");
  }, [alert_sts_cd, ReportBlind]);

  const OpenPopup = useCallback(() => {
    dispatch(PopupChange({ type: "report", active: true, content: ctts_ctts }));
  }, [dispatch]);

  return (
    <div className="report-card">
      <div className={`number`}>-</div>
      <div className="user">{alert_reg_login_nm}</div>
      <div className="declarationLocation">
        {bbs_nm} &gt; {ctts_ctg_nm}
      </div>
      <div className="declarationUser">{ctts_reg_login_nm}</div>
      <div className="declaration">{ctts_ctts}</div>
      <img
        src="/assets/common/report-view.svg"
        alt="img"
        onClick={OpenPopup}
      ></img>
      <div className="declarationType">{alert_type_nm}</div>
      <div className="report-show">
        <ToggleBtn
          isActive={alert_sts_cd === "normal" ? false : true}
          index={0}
          updateActive={Blind}
        />
      </div>
    </div>
  );
};

export default ReportCard;
